/**
 * 22×22 colored square with monospace file-extension text — the visual
 * signal that replaces a generic thumbnail on doc-search cards. Colors
 * match Microsoft / Adobe convention so the glyph reads instantly.
 */

export type TypeGlyphKind = "pptx" | "docx" | "pdf";

const COLORS: Record<TypeGlyphKind, string> = {
  pptx: "#D24726",
  docx: "#2B579A",
  pdf: "#B7472A",
};

export function TypeGlyph({ kind = "pptx" }: { kind?: TypeGlyphKind }) {
  return (
    <div
      style={{
        width: 22,
        height: 22,
        borderRadius: 4,
        flexShrink: 0,
        background: COLORS[kind],
        color: "white",
        fontFamily: "var(--font-mono)",
        fontSize: 8,
        fontWeight: 700,
        display: "grid",
        placeItems: "center",
      }}
    >
      {kind.toUpperCase()}
    </div>
  );
}
